import React from 'react';
import { Dialog } from '@mui/material';
import { useTheme } from '../../../../src/design-system/providers/ThemeProvider';
import { operationalModal, operationalRadii } from '../../../design-system/tokens';

/**
 * PlatformDialog
 * Modal base (wrapper) que aplica o styling global Premium.
 * Os cantos arredondados, fundo dependente do Dark Mode, e as sombras profundas
 * são aplicados neste componente raiz.
 */
const PlatformDialog = ({
  children,
  PaperProps = {},
  BackdropProps = {},
  ...props
}) => {
  const { isDarkMode } = useTheme();

  return (
    <Dialog
      BackdropProps={{
        ...BackdropProps,
        sx: {
          backgroundColor: isDarkMode ? operationalModal.backdrop.dark : operationalModal.backdrop.light,
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          ...BackdropProps.sx
        }
      }}
      PaperProps={{
        ...PaperProps,
        sx: {
          borderRadius: `${operationalRadii.modal}px`,
          overflow: 'clip',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          backgroundColor: 'background.paper',
          backgroundImage: 'none',
          border: '1px solid',
          borderColor: 'divider',
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          boxShadow: isDarkMode ? operationalModal.shadow.dark : operationalModal.shadow.light,
          // Garante que o primeiro campo nunca fique sob o header fixo do modal
          '& .MuiDialogContent-root': {
            paddingTop: '24px',
          },
          ...PaperProps.sx
        }
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default PlatformDialog;
